var map = {
	"./ar.json": [
		67761
	],
	"./de.json": [
		52015,
		2015
	],
	"./en.json": [
		13570
	],
	"./es.json": [
		81593
	],
	"./fa.json": [
		1560,
		1560
	],
	"./fr.json": [
		46586
	],
	"./hi.json": [
		76229
	],
	"./hy.json": [
		40822,
		822
	],
	"./it.json": [
		46443,
		6443
	],
	"./ja.json": [
		12219,
		2219
	],
	"./ka.json": [
		71278,
		1278
	],
	"./ko.json": [
		15414,
		5414
	],
	"./mg.json": [
		25719,
		5719
	],
	"./pt.json": [
		72910
	],
	"./ro.json": [
		1377,
		1377
	],
	"./ru.json": [
		57604
	],
	"./sv.json": [
		81937,
		1937
	],
	"./sw.json": [
		51095,
		1095
	],
	"./tr.json": [
		94050,
		4050
	],
	"./uk.json": [
		48382,
		8382
	],
	"./ur.json": [
		93278,
		3278
	],
	"./zh-Hant.json": [
		3229,
		3229
	],
	"./zh.json": [
		93883
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 64222;
module.exports = webpackAsyncContext;